import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EquipmentService {

  private equipmentURL =  `${environment.baseUri}equipment/`;


  constructor(private http: HttpClient) { }

  equipmentInfo(obj) {
    return this.http.post(this.equipmentURL, obj).toPromise();
  }
}
